import React from 'react';
import { Modal, Spinner } from './ui';
import { useReportShare } from './useReportShare';
import { REPORT_SIZE_OPTIONS } from '../utils/reportExport';

// Desktop Share / Export: the report on the left as it will print, the choices
// on the right. Every list page opens this with the columns it already shows.
export default function ReportShareDesktop(props) {
  const vm = useReportShare(props);
  const {
    kind, setKind, orientation, setOrientation, density, setDensity, busy, previewUrl, fileName, pages, setPages, pageLabel,
    rowCount, columnCount, sections, title, subtitle, save, print, shareFile, canShareFile, close,
  } = vm;

  return (
    <Modal
      widest dense className="share-modal" title={`Share / Export — ${title}`} onClose={close}
      footer={<>
        <button className="btn light" onClick={close}>Close</button>
        <div className="spacer" style={{ flex: 1 }} />
        <button className="btn light" disabled={!!busy} onClick={print}>🖨 Print</button>
        <button className="btn light" disabled={!!busy} onClick={() => save('excel')}>
          {busy === 'save' ? 'Saving…' : '↓ Excel'}
        </button>
        <button className="btn primary" data-save="primary" disabled={!!busy} onClick={() => save('pdf')}>
          {busy === 'save' ? 'Saving…' : '↓ PDF'}
        </button>
      </>}
    >
      <div className="share-layout">
        <div className="share-preview">
          {kind !== 'pdf' ? (
            <div className="card card-pad empty" style={{ height: '100%' }}>
              An Excel file has no preview — save it and open it in Excel.
            </div>
          ) : busy === 'preview' || !previewUrl ? (
            <div className="card card-pad" style={{ height: '100%', display: 'grid', placeItems: 'center' }}><Spinner /></div>
          ) : (
            <iframe title="Report preview" src={previewUrl} className="share-frame" />
          )}
        </div>

        <div className="share-side">
          <div className="step-label">Format</div>
          <div className="chips-row" style={{ marginBottom: 14 }}>
            {[['pdf', '📄 PDF'], ['excel', '📊 Excel']].map(([value, label]) => (
              <button key={value} type="button" className={'chip-toggle' + (kind === value ? ' on' : '')}
                onClick={() => setKind(value)}>{label}</button>
            ))}
          </div>

          {kind === 'pdf' && (
            <>
              <div className="step-label">Page</div>
              <div className="chips-row" style={{ marginBottom: 10 }}>
                {[['portrait', 'Portrait'], ['landscape', 'Landscape']].map(([value, label]) => (
                  <button key={value} type="button" className={'chip-toggle' + (orientation === value ? ' on' : '')}
                    onClick={() => setOrientation(value)}>{label}</button>
                ))}
              </div>
              {/* Reprinting one page of a long list: the sheet that jammed,
                  or the only page somebody still needs. */}
              <div className="step-label">Pages</div>
              <div className="chips-row" style={{ marginBottom: 4 }}>
                <input className="rs-pages" value={pages} placeholder="all"
                  title={'Which pages to print - "2", "1,4", "2-5". Blank prints everything.'}
                  onChange={(e) => setPages(e.target.value.replace(/[^\d,\-\s]/g, ''))} />
                {pages.trim() && (
                  <button type="button" className="btn light sm" onClick={() => setPages('')}>All</button>
                )}
              </div>
              {pageLabel && <div className="muted" style={{ fontSize: 12, marginBottom: 12 }}>{pageLabel}</div>}
              <div className="step-label">Text size</div>
              <div className="chips-row" style={{ marginBottom: 12 }}>
                {REPORT_SIZE_OPTIONS.map(([value, label]) => (
                  <button key={value} type="button" className={'chip-toggle' + (density === value ? ' on' : '')}
                    onClick={() => setDensity(value)}>{label}</button>
                ))}
              </div>
            </>
          )}

          <div className="step-label">This report</div>
          <div className="muted" style={{ fontSize: 12.5, lineHeight: 1.7 }}>
            {subtitle && <div>{subtitle}</div>}
            <div>{rowCount} {rowCount === 1 ? 'row' : 'rows'} · {columnCount} {sections ? (columnCount === 1 ? 'section' : 'sections') : 'columns'}</div>
            <div style={{ wordBreak: 'break-all' }}>{fileName}</div>
          </div>

          {canShareFile && (
            <button className="btn light" style={{ width: '100%', marginTop: 14 }} disabled={!!busy} onClick={shareFile}>
              ↗ Send to another app
            </button>
          )}
        </div>
      </div>
    </Modal>
  );
}
